import { Field, FieldArray, Form, Formik } from "formik";
import { useState } from "react";
import { Form as BForm, Card, Col, Row } from "react-bootstrap";
import TextInput from "../../../../../components/formfields/InputField";
import { useDispatch, useSelector } from "react-redux";
import { addHomeDataAction } from "../actions";
import featureImg from "../../../../../assets/images/feature-img.png";
import AddTestimonial from "./AddTestimonial";
import CustomPicker from "../FreebiesSection/CustomPicker";
import { toast } from "react-toastify";

const testimonial = {
  name: "John Smit",
  color: "black",
  description: "Not a good nigga!!",
  image: featureImg,
};

const Testimonial = ({ item, arrayHelpers, uploadAction, setFieldValue, idx, edit, uploadNewAction }: any) => {
  const [showEditTestimonial, setShowEditTestimonial] = useState<boolean>(false);
  return (
    <tr>
      <td>
        <p className="fw-bold mb-2">{item.name}</p>
        <p className="mb-0">{item.description}</p>
      </td>
      <td>
        <img src={item.dummyImage || item.image} style={{ maxWidth: "150px" }} alt="Image" />
      </td>
      <td>
        <div className="d-flex align-items-center justify-content-center h-100">
          <a className="mx-1 my-2" onClick={() => edit && arrayHelpers.remove(idx)}>
            <i className="fa-regular fa-trash-can text-darkblue"></i>
          </a>

          <a className="mx-1 my-2" onClick={() => edit && setShowEditTestimonial(true)}>
            <i className="fa-regular fa-pen-line text-darkblue"></i>
          </a>
          {showEditTestimonial && (
            <AddTestimonial
              show={showEditTestimonial}
              setShow={setShowEditTestimonial}
              editData={item}
              customArrayHelper={arrayHelpers}
              uploadAction={uploadAction}
              setFieldValue={setFieldValue}
              index={idx}
              uploadNewAction={uploadNewAction}
            />
          )}
        </div>
      </td>
    </tr>
  );
};

const TestimonialSection = ({ props }: any) => {
  const [TestimonialEdit, setTestimonialEdit] = useState<boolean>(false);
  const [showEditTestimonial, setShowEditTestimonial] = useState<boolean>(false);
  const dispatch = useDispatch();
  const testimonial_state = useSelector((state: any) => state?.home?.home_data);

  const testimonialState = {
    testimonial_header: testimonial_state?.testimonial_header ? testimonial_state?.testimonial_header : "",
    testimonial_color: testimonial_state?.testimonial_color ? testimonial_state?.testimonial_color : "#7ADBD1",
    testimonial_header_tag: testimonial_state?.testimonial_header_tag ? testimonial_state?.testimonial_header_tag : "",
    testimonial_description: testimonial_state?.testimonial_description ? testimonial_state?.testimonial_description : "",
    testimonial_button: testimonial_state?.testimonial_button ? testimonial_state?.testimonial_button : "",
    testimonial_button_link: testimonial_state?.testimonial_button_link ? testimonial_state?.testimonial_button_link : "",
    testimonials: testimonial_state?.testimonials ? testimonial_state?.testimonials : [],
  };
  const handleTestimonialState = (values: any) => {
    if ((!values.testimonial_button && values.testimonial_button_link) || (values.testimonial_button && !values.testimonial_button_link)) {
      toast.error("Please validate the form");
    } else {
      let newArray = values?.testimonials?.map((obj: any) => {
        const { dummyImage, oldImage, ...rest } = obj; // Using object destructuring to exclude the 'name' property
        return rest;
      });
      const form_data = new FormData();
      form_data.append("id", "testimonial");
      form_data.append("testimonial_header", values.testimonial_header);
      form_data.append("testimonial_color", values.testimonial_color);
      form_data.append("testimonial_header_tag", values.testimonial_header_tag);
      form_data.append("testimonial_description", values.testimonial_description);
      form_data.append("testimonial_button", values.testimonial_button);
      form_data.append("testimonial_button_link", values.testimonial_button_link);
      form_data.append("testimonials", JSON.stringify(newArray));
      dispatch(addHomeDataAction(form_data, setTestimonialEdit, "add-testimonial-section"));
      console.log("testimonial_values", values);
      setTestimonialEdit(false);
    }
  };

  return (
    <Formik enableReinitialize initialValues={testimonialState} onSubmit={handleTestimonialState}>
      {({ values, handleChange, handleBlur, setFieldValue }) => {
        return (
          <Form autoComplete="off">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fs-lg }">Testimonial Section</h6>
                {TestimonialEdit ? (
                  <button className="btn btn-primary" type="submit">
                    <i className="fa-regular fa-pen-to-square"></i> Save
                  </button>
                ) : (
                  <span onClick={() => setTestimonialEdit(true)} className="btn btn-green">
                    <i className="fa-regular fa-pen-to-square"></i> Edit
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${TestimonialEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                ></div>
                <Row className="gy-3">
                  <Col lg="6">
                    <BForm.Label>Header</BForm.Label>
                    <Field
                      name="testimonial_header"
                      component={TextInput}
                      value={values.testimonial_header}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Header"
                      readOnly={!TestimonialEdit}
                      className={TestimonialEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col lg="6">
                    {/* <BForm.Label>Header Color</BForm.Label>
                    <div className="position-relative colorPickerInput">
                      <label
                        className="colorLabel"
                        style={{ background: `${values.testimonial_color}` }}
                        onClick={() => {
                          TestimonialEdit && setShowPicker(!showPicker);
                        }}
                      ></label>

                      <BForm.Control type="text" disabled={true}></BForm.Control>
                      <Button
                        className="addBtn"
                        disabled={!TestimonialEdit}
                        onClick={() => {
                          showPicker ? selectColor(setFieldValue) : setShowPicker(true);
                        }}
                      >
                        +
                      </Button>

                      {showPicker && TestimonialEdit && (
                        <div className="colorPickerBox mt-5">
                          <ColorPicker value={color} onChange={setColor} />
                        </div>
                      )}
                    </div> */}
                    <CustomPicker
                      setFieldValue={setFieldValue}
                      name="testimonial_color"
                      value={values.testimonial_color}
                      label="Header Color"
                      edit={TestimonialEdit}
                    />
                  </Col>
                  <Col xs={12}>
                    <label className="form-label">Header Tag</label>
                    <Field
                      name="testimonial_header_tag"
                      component={TextInput}
                      value={values.testimonial_header_tag}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Header Tag"
                      readOnly={!TestimonialEdit}
                      className={TestimonialEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col xs={12}>
                    <label className="form-label">Header Description</label>
                    <Field
                      name="testimonial_description"
                      value={values.testimonial_description}
                      component={TextInput}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Header description"
                      multiline
                      readOnly={!TestimonialEdit}
                      className={TestimonialEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col sm={4}>
                    <label className="form-label">Button</label>
                    <Field
                      name="testimonial_button"
                      component={TextInput}
                      value={values.testimonial_button}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Button"
                      readOnly={!TestimonialEdit}
                      className={TestimonialEdit ? "editField" : ""}
                    />
                    {!values.testimonial_button && values.testimonial_button_link ? <div className="errorMessage">Enter button text</div> : null}
                  </Col>
                  <Col sm={8}>
                    <label className="form-label">Button Link</label>
                    <Field
                      name="testimonial_button_link"
                      component={TextInput}
                      value={values.testimonial_button_link}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Button Link"
                      readOnly={!TestimonialEdit}
                      className={TestimonialEdit ? "editField" : ""}
                    />
                    {values.testimonial_button && !values.testimonial_button_link ? <div className="errorMessage">Enter button Link</div> : null}
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <FieldArray
              name="testimonials"
              render={(arrayHelpers) => (
                <div className="position-relative">
                  <div
                    className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${TestimonialEdit ? "d-none" : ""}`}
                    style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                  ></div>
                  <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fs-lg }">Testimonial List</h6>

                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        disabled={!TestimonialEdit}
                        onClick={() => TestimonialEdit && setShowEditTestimonial(true)}
                      >
                        <i className="fa-regular fa-plus"></i> Add Testimonial
                      </button>
                      {showEditTestimonial && (
                        <AddTestimonial
                          show={showEditTestimonial}
                          setShow={setShowEditTestimonial}
                          uploadAction={props.uploadFileAction}
                          customArrayHelper={arrayHelpers}
                          uploadNewAction={props.uploadFileNewAction}
                        />
                      )}
                    </Card.Header>
                    <Card.Body>
                      <div className="table-responsive cardTable">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th className="text-left">Name</th>
                              <th className="text-center">Image</th>
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.testimonials.map((item: any, idx: number) => {
                              return (
                                <Testimonial
                                  key={item.name}
                                  item={item}
                                  arrayHelpers={arrayHelpers}
                                  uploadAction={props.uploadFileAction}
                                  setFieldValue={setFieldValue}
                                  idx={idx}
                                  edit={TestimonialEdit}
                                  uploadNewAction={props.uploadFileNewAction}
                                />
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              )}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default TestimonialSection;
